import { Component, OnInit, OnDestroy, ElementRef, ViewChild, Input, TemplateRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { OrderService, AuthenticationService, ShipmentService, ScannerService, JobService } from '../../../services';

// import {  COMMENT, QUEUED, PRINTED, PREPRESS } from '../../../../ngrx/status-types';
// import {  SET_ORDER_DETAILS_VIEW, SET_JOB_DETAILS_VIEW } from '../../../../ngrx/actions';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { TranslateService } from 'app/i18n';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SET_JOB_DETAILS_VIEW, SET_SHIPMENT_DETAILS_VIEW } from 'ngrx/actions';
import { HOLD, SHIPMENTS, READY, ID_CARD, MARKETPLACEEMAILS, CUT } from 'ngrx/status-types';
import { Subscription, Observable } from 'rxjs';
import { ActivityHistory, Job, Shipment } from 'app/models';

import { accessories, accessoryImage } from 'ngrx/material-type';
import { SHEETS } from 'ngrx/category-types';

@Component({
  selector: 'qa-okay-modal',
  templateUrl: 'qa-okay-modal.component.html',
  styleUrls:   ['qa-okay-modal.component.scss']
})
export class QaOkayModal implements OnInit, OnDestroy {
  @ViewChild('qaOkayFullModal') qaOkayFullModal  : TemplateRef<any>;
  @ViewChild('scanIdModal')     scanIdModal      : TemplateRef<any>;
  @ViewChild('wrongScanIdModal') wrongScanIdModal      : TemplateRef<any>;
  @ViewChild('orderErrorModal') orderErrorModal  : TemplateRef<any>;
  @Input('jobs')      jobs;
  @Input('shipment')  shipment;
  @Input('order')     order;
  holdJobValueSubscr  : Subscription;
  getShipmentListSubscr: Subscription;
  process             : Observable<string>;
  jobHoldForm         : FormGroup;
  jobsCheck           : any = [];
  accessoriesCheck    : any = [];
  thankYouCardCheck   : any = [];
  ticketsCheck        : any = [];
  inplaceStickerCheck : any = [];
  jobsQaOkay          : boolean = false;
  qaHoldPrompt        : boolean = false;
  disableHoldSubmit   : boolean = true;
  isAdmin             : boolean;
  isSupervisor        : boolean;
  math                = Math;
  category            : string;
  accessories         : any;
  accessoryImage      : any;
  shipmentList        : Observable<Shipment[]>;
  initSubscriptions   : Subscription[]; 
  qaOkayFullModalRef  : BsModalRef;
  scanIdModalRef      : BsModalRef;
  wrongScanIdModalRef      : BsModalRef;
  orderErrorModalRef  : BsModalRef;
  orderError          : boolean = false;
  overcountError      : boolean = false;
  overCountJob        : string;
  qaOkayList                 : any[];
  thankYouImgURL      : string;
  thankYouFlag        : boolean = false;
  inplaceStickerImgURL      : string;
  inplaceStickertFlag       : boolean = false;
  
  constructor(
    private authService      : AuthenticationService,
    private orderService     : OrderService,
    private shipmentService  : ShipmentService,
    private fb               : FormBuilder,
    private store            : Store<any>,
    private translate        : TranslateService,
    private modalService     : BsModalService,
    private scanner          : ScannerService
  ) {
    this.shipmentList    = this.shipmentService.getShipmentList();
    this.process         = this.authService.getCurrentProcess();
    this.isAdmin         = this.authService.userIsAdmin();
    this.isSupervisor    = this.authService.userIsSupervisor();
    this.accessories     = accessories;
    this.accessoryImage  = accessoryImage;
    this.thankYouImgURL  = 'https://s3.amazonaws.com/impreso.roll.asset/ThankYouCard_Updated.png';
    this.inplaceStickerImgURL  = 'https://s3.us-east-1.amazonaws.com/impreso.sheet.asset/InPackingStickers.png';
  }
  ngAfterViewInit() {
    // console.log(this.modalService.getModalsCount())
    // setTimeout(() => this.textInput.nativeElement.focus());

  }
  
  ngOnInit(): void {
    // console.log("is admin : ",this.isAdmin)
    this.resetJobChecks();
    this.setHoldFormValues();
    // check after ghs sku with no scanner - remove when the sku gets scanner
    this.qaChecked();
    //
    this.initSubscriptions = [
      this.process.subscribe(process => {
        this.category = process;
      }),
      this.scanner
      ._qaScanListener
      .subscribe(id => {
        const ID       = id.replace(/[^A-Za-z0-9-]/g, '');
        const [ l, t ] = this.scanner._triggers;
        const location = this.scanner._locations[l];
        console.log(`QAOKAY ID ${ID} scanned at ` + location);
        // const type     = this.scanner._types[t];
        const [ orderID, jobID ] = ID.split('-');
        if(location === SHIPMENTS || location === CUT) {
          // Caution that we added CUT here, if they scan only the job at QA step, it causes job to go back to PACKING
          // The scanenrs should be scanner ORDERID-JOB so this scenario won't happen.
          if(this.jobsQaOkay) {
            if(ID.charAt(0) === '0'){
              this.setShipmentReady(ID);
            }else{
              this.openWrongScanIdModal();
            }
            // if(this.category == 'sheets' && orderID.charAt(0) === '0' && orderID.length === 7) {
            //   this.setShipmentReady(ID);
            // } else {
            //   this.setShipmentReady(null);
            // }
          } else {
            let orderJobFound = false;
            for(let i = 0; i < this.jobsCheck.length; i++) {
              let job = this.jobsCheck[i];
              if((job.id === ID || job.id === jobID) && (job.orderId == this.order.id) && this.orderError === false && this.overcountError === false) {
                orderJobFound = true;
                if(this.jobsCheck[i].smallQty && this.category == SHEETS) {
                  if(this.jobsCheck[i].curQty < this.jobsCheck[i].qty) {
                    this.jobsCheck[i].curQty++;
                    if(this.jobsCheck[i].curQty ===  this.jobsCheck[i].qty) {
                      this.jobsCheck[i].qaChecked = true;
                    }
                  } else {
                    if(this.overcountError == false) {
                      console.log("OVERCOUNT ERROR")
                      this.overcountError = true;
                      this.overCountJob   = this.jobsCheck[i].id;
                      this.orderErrorModalRef = this.modalService.show(this.orderErrorModal, {
                        animated: false,
                        class : 'modal-lg'
                      });
                    }
                  }
                } else {
                  // OA
                  this.jobsCheck[i].qaChecked = true;
                }
                this.qaChecked();
                break;
              } 
            }
                          
            if(orderJobFound === false) {
              if(this.orderError == false) {
                console.log("ORDER ERROR")
                this.orderError = true;
                this.orderErrorModalRef = this.modalService.show(this.orderErrorModal, {
                  animated: false,
                  class : 'modal-lg'
                });
              }
            }
          }
        }
      })
    ]
  }

closeModal(): void {
  this.orderErrorModalRef.hide();
  this.overcountError = false;
  this.overCountJob   = null;
  this.orderError = false;
}

  ngOnDestroy(): void {
    console.log("Destroying...");
    this.holdJobValueSubscr.unsubscribe();
    // this.getShipmentListSubscr.unsubscribe();
    this.initSubscriptions.forEach(subscription => subscription.unsubscribe());
  }

  qaChecked() {
    let qaOkay = true;
      for(let i = 0; i < this.jobsCheck.length; i++) {
        if(!this.jobsCheck[i].qaChecked) {
          qaOkay = false;
          break;
        }
        if(this.accessoriesCheck[i] != null && !this.accessoriesCheck[i].qaChecked) {
          qaOkay = false;
          break;
        }
        if(this.category == SHEETS &&
           this.thankYouCardCheck[i] != null && !this.thankYouCardCheck[i].qaChecked ||
           this.inplaceStickerCheck[i] != null && !this.inplaceStickerCheck[i].qaChecked) {
          qaOkay = false;
          break;
        }
        if(this.category == SHEETS && this.ticketsCheck[i] != null && !this.ticketsCheck[i].qaChecked) {
          qaOkay = false;
          break;
        }

      }
    this.jobsQaOkay = qaOkay;
    if(this.jobsQaOkay && (this.isAdmin == false && this.isSupervisor == false) && this.category == SHEETS) {
      this.openScanIdModal(); 
    }
  }

  setHoldFormValues() {
    this.jobHoldForm = this.fb.group({
      holdJobs       : this.fb.array([])
    });

    const jobList = this.jobs.map(job => this.fb.group({
      hold       : [false],
      id         : [job.id],
      holdReason : [''],
    }));

    this.jobHoldForm.setControl('holdJobs', this.fb.array(jobList, this.jobsValidator));
    this.holdJobOnChanges();
    this.disableHoldSubmit = true;
  }

  get holdJobs(): FormArray {
    return this.jobHoldForm.get('holdJobs') as FormArray;
  };

  resetJobChecks() {
    this.accessoriesCheck = [];
    this.thankYouCardCheck = [];
    this.ticketsCheck = [];
    this.inplaceStickerCheck = [];
    
    let qaChecked = (this.isAdmin || this.isSupervisor) ? true : false;
    let category;
    let includesTicket = false; 
    this.jobs.forEach((job)=>{
      let smallQty = false;
      let qty = job.qty;
      let curQty = job.qty;
      category = job.category;
      if(job.qty <= 6 && job.category == SHEETS && (job.product && job.product.description == 'labels')) {
        smallQty = true;
        curQty = 0;
      }

      if((job.product && job.product.description == 'tickets')){ includesTicket = true; }

      if(job.product.sku === '727826476000030') {
        console.log('ghs and sku match no scanner match')
        this.jobsCheck.push({id: job.id, orderId: job.orderId, qaChecked: true, qaHold: false, smallQty: smallQty, qty, curQty, holdReason: ""});
      } else {
        this.jobsCheck.push({id: job.id, orderId: job.orderId, qaChecked: qaChecked, smallQty: smallQty, qty, curQty, qaHold: false, holdReason: ""});
      }

      if(this.accessories[job.product.sku]) {
        let totalQty = job.qty+(job.qty/4);
        let description : any = this.translate.instant(this.accessories[job.product.sku]);
        // description = description.replace('totalQty',totalQty).replace('totalQty_25',Math.ceil(totalQty/25));
        // let qty = description.includes('DKM73202') ? Math.ceil(totalQty/25) : job.qty;
        // let qty = job.qty;
        // TBD: 80 or 20?
        let qty = job.qty;
        if(description.includes('X2820003')) {
          let total_tags = qty * (+job.oaDetails.template.labels_per_sheet);
          qty = Math.ceil(total_tags/80) // Packs of 80?
          qaChecked = true;
        };
        this.accessoriesCheck.push({id: job.id, qaChecked: qaChecked, sku: job.product.sku,description: description, qty, accessory: this.accessories[job.product.sku]})
        qaChecked = (this.isAdmin || this.isSupervisor) ? true : false;; // Set it back for next job
      } else {
        this.accessoriesCheck.push(null);
      }
      console.log("this.accessoriesCheck : ", this.accessoriesCheck);
    });
    
    //Add thank you card for AVERY orders only. If marketplace order dont need to add thank you card
    if(category == SHEETS){
      let marketplace: any = MARKETPLACEEMAILS.map(email => email.toLowerCase());
      let marketplaceFlag = null;
      let dropshipFlag = (this.order && this.order.customer && this.order.customer.dropship) || null;

      if(this.shipment && this.shipment.address && this.shipment.address.email){ marketplaceFlag = marketplace.includes(this.shipment.address.email.toLowerCase()) }
      
      if(marketplaceFlag || dropshipFlag){
        this.thankYouCardCheck.push(null);
        this.thankYouFlag = false
        this.inplaceStickertFlag = false
      }else{
        this.thankYouCardCheck.push({qaChecked: qaChecked})
        this.inplaceStickerCheck.push({qaChecked: qaChecked})
        this.thankYouFlag = true;
        this.inplaceStickertFlag = true;
      }
      
      if(includesTicket){
        this.ticketsCheck.push({qaChecked: qaChecked})
      }else{
        this.ticketsCheck.push(null);
      }

    }
    this.setHoldFormValues();
  }

  jobsValidator(control: AbstractControl): any {
    let valid = false;
    control['controls'].forEach(formControl => {
      if (formControl.value.hold) {
        valid = true;
      }
    });

    return valid ? null: { atLeastOneSelected: false };
  }

  holdJobOnChanges() {
    this.holdJobValueSubscr = this.jobHoldForm.valueChanges.debounceTime(300).subscribe(val => {
      let disableHoldSubmit = true;
      for(let i = 0; i < val.holdJobs.length; i++) {
        let job = val.holdJobs[i];
        if(job.hold === true) {
          if(job.holdReason === null || job.holdReason.match(/^ *$/) !== null) {
            disableHoldSubmit = true;
            break;
          } else {
            disableHoldSubmit = false;
          }
        } else {
          this.holdJobs.at(i).patchValue({
            holdReason : '',
          });
        }
      }
      this.disableHoldSubmit = disableHoldSubmit;
    });
  }

  holdOrderAndJobs(event: Event): void {
    event.stopPropagation();
    this.store.dispatch({
      type: SET_SHIPMENT_DETAILS_VIEW,
      payload: { loading: true }
    });

    this.jobHoldForm.get('holdJobs').value.forEach(job => {
      // console.log("current hold job value: ", job);
      if(job.hold && (job.holdReason !== null || job.holdReason.match(/^ *$/) === null)) {

        const jobToUpdate = this.jobs.filter(fullJob => fullJob.id === job.id)[0];
        // console.log(" UPDATING JOB TO HOLD : ", jobToUpdate);
        this.orderService.setJobStatus(
          jobToUpdate,
          HOLD,
          this.translate.instant('shipping'),// this.translate.instant(this.changeHoldReason),
          undefined,
          job.holdReason
        );
      }
    });

    this.modalService.hide(1);
  }

  openScanIdModal() {
    if((!this.isAdmin && !this.isSupervisor) && this.category == SHEETS) {
      this.scanIdModalRef = this.modalService.show(this.scanIdModal, {
        animated: false,
        class : 'modal-lg'
      });
    } else {
      this.setShipmentReady('admin')
    }
  }

  openWrongScanIdModal() {
    if(this.category == SHEETS) {
      this.wrongScanIdModalRef = this.modalService.show(this.wrongScanIdModal, {
        animated: false,
        class : 'modal-lg'
      });
    } else {
      this.setShipmentReady('admin')
    }
  }

  setShipmentReady(id): void {
    // event.stopPropagation();

    this.getShipmentListSubscr = this.shipmentList.subscribe(shipments => { 
      this.qaOkayList = shipments && shipments.filter(shipment => shipment.shipmentStatus === READY);
         
      console.log(this.qaOkayList)
      if(this.qaOkayList.length < 2) {
        let activity: ActivityHistory;
        if(this.category == SHEETS) {
          activity = {
            activity  : "qa Ok",
            //note      : this.isAdmin ? 'QA OK done - Admin override' : "Employee ID: " + id,
            note      : (this.isAdmin || this.isSupervisor) ? `QA OK done - Admin override (Employee ID: ${id})` : "Employee ID: " + id,
            user      : this.authService.getCurrentUser(),
            timestamp : (new Date).getTime().toString(),
            comment   : null,
          };
        } else {
          activity = {
            activity  : "qa Ok",
            note      : 'qa Ok',
            user      : this.authService.getCurrentUser(),
            timestamp : (new Date).getTime().toString(),
            comment   : null,
          };
        }
        if(this.shipment.activity_history && Array.isArray(this.shipment.activity_history)) {
          this.shipment.activity_history.unshift(activity);
        } else {
          this.shipment.activity_history = [activity]
        }
        // if(this.layout === 'oa' && this.order && this.order.jobs.length === 1 && this.jobs[0].qty < 26) {
        //   this.shipment.
        // }
        this.shipmentService.qaCheckOK(this.shipment);
        this.modalService.hide(1);
      } else {
        this.qaOkayFullModalRef = this.modalService.show(this.qaOkayFullModal, {
          animated: false,
          class : 'modal-lg'
        });
      }
    })
    this.getShipmentListSubscr.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/shared/modals/qa-okay-modal/qa-okay-modal.component.ts